<script>
	export let checked
</script>

<div class="input-group">
	<label>
		<input type=checkbox bind:checked={checked}>
		<span class="checkbox-label">
			<slot></slot>
		</span>
	</label>
</div>

<style lang="scss">
@import '../scss/variables.scss';

.checkbox-label {
	padding-left: 10px;
	color: $medium-grey
}
.input-group {
	label {
		display: flex;
		justify-content: center;
	}
	input {
		margin-bottom: 0;
		margin-left: -10px;
	}
}
</style>